var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-content"},[_c('div',{staticClass:"content-title"},[_c('div',[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.jumpText)?_c('div',[_c('a',{attrs:{"href":_vm.jumpUrl}},[_vm._v(_vm._s(_vm.jumpText))])]):_vm._e()]),_c('div',{staticClass:"content-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }